module.exports = __webpack_public_path__ + "static/media/partner_4_logo.b40674f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner_4_logo.png
// module id = 556
// module chunks = 0